module.exports = __webpack_public_path__ + "img/table.c61d3bd2.png";